import { Helmet } from "react-helmet-async";
import { useLang } from "@/context/LanguageContext";
import { LOCALES } from "@/i18n/translations";

const SITE_URL = "https://www.othryx.de";
const DEFAULT_OG = `${SITE_URL}/og-default.jpg`;
/**
 * Per-route SEO meta + Open Graph + hreflang alternates.
 * Pass `pathKey` ("home" | "about" | "services" | "contact" | "impressum" | "privacy")
 * — it will look up t.seo[pathKey] from translations.
 */
export default function SEO({ pathKey, path }) {
    const { t, lang } = useLang();
    const seo = (t.seo && t.seo[pathKey]) || t.seo?.home || {};
    const url = `${SITE_URL}${path || "/"}`;
    const title = seo.title || "OTHRYX S.R.L.";
    const description = seo.description || "";
    const ogImage = seo.image || DEFAULT_OG;

    return (
        <Helmet>
            <html lang={lang} />
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:site_name" content="OTHRYX S.R.L." />
            <meta property="og:locale" content={lang === "de" ? "de_DE" : lang === "ro" ? "ro_RO" : "en_GB"} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />
            {LOCALES.map((code) => (
                <link
                    key={code}
                    rel="alternate"
                    hrefLang={code}
                    href={`${SITE_URL}${path || "/"}`}
                />
            ))}
            <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${path || "/"}`} />
        </Helmet>
    );
}
